import { apiRequest } from "@portal/lib/ky/utils";
import { CreatePTP, PTPDetails, PTPList } from "@portal/types/entities/ptp";
import { PageList } from "@portal/types/page-list";
import { RequestConfig } from "../types/common";

export async function getPTPList(params: RequestConfig<unknown>) {
  const { page, size, filters } = params;
  const data = await apiRequest<
    RequestConfig<unknown>["filters"],
    PageList<PTPList, unknown>
  >({
    method: "POST",
    url: "v1/ptps/report",
    data: filters,
    searchParams: { page, size },
  });
  return await data.json();
}

export async function raiseAPromiseToPay(params: CreatePTP) {
  const data = await apiRequest<CreatePTP, CreatePTP>({
    method: "POST",
    url: "v1/ptps",
    data: { ...params },
  });
  return await data.json();
}

export async function raiseAPromiseToPayBulk(params: CreatePTP) {
  return await apiRequest<CreatePTP, undefined>({
    method: "POST",
    url: "v1/ptps/bulk",
    data: { ...params },
  });
}
export async function getPTPDetails(params?: string) {
  const data = await apiRequest<unknown, PTPDetails>({
    method: "GET",
    url: `v1/ptps/${params?.toString()}`,
  });
  return await data.json();
}

export async function deletePtp(id?: string) {
  await apiRequest<unknown, undefined>({
    method: "DELETE",
    url: `v1/ptps/${id}`,
  });
}
export async function updatePTPStatus(params: Partial<CreatePTP>, id?: string) {
  const data = await apiRequest<Partial<CreatePTP>, PTPDetails>({
    method: "PATCH",
    url: `v1/ptps/${id}`,
    data: params,
  });
  return await data.json();
}
